import { FC, useEffect } from "react";
import { MenuTipo } from "@/models";
import { useMenusContext } from "@/context";
import { AsideMenuItemWithSub } from "./aside-menu-item-with-sub";
import { AsideMenuItem } from "./aside-menu-item";

export const AsideMenuMain: FC = () => {
  const menus = useMenusContext();

  return (
    <>
      {menus?.map((menu) => (menu.tipo === MenuTipo.ÚNICO
        ? (
          <AsideMenuItem key={menu.id} menu={menu} />
        )
        : (
          <AsideMenuItemWithSub key={menu.id} menu={menu}>
            {menu.menusFilho?.map((menuFilho) => (
              <AsideMenuItem key={menuFilho.id} menu={menuFilho} />
            ))}
          </AsideMenuItemWithSub>
        )))
      }
    </>
  );
};

